const ComponentSettingsConstant = {
    optionGroups: {
        CORE_SETTINGS: 'OptionGroupConstant.coreSettings',
        DISPLAY_SETTINGS: 'OptionGroupConstant.displaySettings',
        EDITABILITY_SETTINGS: 'OptionGroupConstant.editabilitySettings',
        VISIBILITY_SETTINGS: 'OptionGroupConstant.visibilitySettings',
        REQUIRED_SETTINGS: 'OptionGroupConstant.requiredSettings',
        VALIDATION_SETTINGS: 'OptionGroupConstant.validationSettings',
        VALUE_SETTINGS: 'OptionGroupConstant.valueSettings',
        COMPONENT_SPECIFIC_SETTINGS: 'OptionGroupConstant.componentSpecificSettings'
    }
};

angular.module('ums.configuration')
    .constant('componentSettingsConstant', ComponentSettingsConstant);
